// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"2d09cf21","498":"3eeb0f24","703":"5c27b093"}[chunkId] + ".chunk.js";
};